export default "__VITE_ASSET__DYIruh_Q__"